function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "19_Test",
    id: "_19_Test"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,62H7a1,1,0,0,1-1-1V3A1,1,0,0,1,7,2H53a1,1,0,0,1,1,1V61A1,1,0,0,1,53,62Z",
    style: {
      fill: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,35H11a1,1,0,0,1-1-1V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,17,35Z",
    style: {
      fill: "#febc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,33a1,1,0,0,1-1-1V27H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V33Z",
    style: {
      fill: "#edaa03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,45H11a1,1,0,0,1-1-1V38a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,17,45Z",
    style: {
      fill: "#febc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,55H11a1,1,0,0,1-1-1V48a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,17,55Z",
    style: {
      fill: "#febc00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 15,
    x: 21,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 10,
    x: 21,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 14,
    x: 21,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#f74e0c"
    },
    transform: "translate(-15.32 20.015) rotate(-45)",
    width: 9.899,
    x: 11.55,
    y: 27.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#f74e0c"
    },
    transform: "translate(-22.391 22.944) rotate(-45)",
    width: 9.899,
    x: 11.55,
    y: 37.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#f74e0c"
    },
    transform: "translate(-29.462 25.873) rotate(-45)",
    width: 9.899,
    x: 11.55,
    y: 47.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 6,
    x: 14,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    style: {
      fill: "#0455bf"
    },
    width: 2,
    x: 16,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 6,
    x: 36,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    style: {
      fill: "#0455bf"
    },
    width: 2,
    x: 38,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#0455bf"
    },
    width: 2,
    x: 22,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 5,
    x: 22,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 5,
    x: 22,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 5,
    x: 22,
    y: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,19H29V17h3V16H30a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4v2H31v1h2a1,1,0,0,1,1,1v3A1,1,0,0,1,33,19Z",
    style: {
      fill: "#0455bf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 2,
    x: 37,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#0455bf"
    },
    width: 2,
    x: 41,
    y: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,43a1,1,0,0,1-1-1V37H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V43Z",
    style: {
      fill: "#edaa03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,53a1,1,0,0,1-1-1V47H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V53Z",
    style: {
      fill: "#edaa03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.981 21.192 50.839 23.335 34.414 39.759 32.986 44.044 32 46.459 34.414 45.472 38.699 44.044 54 28.743 54 20.174 52.981 21.192",
    style: {
      fill: "#dfeaef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6.059,
    style: {
      fill: "#f74e0c"
    },
    transform: "translate(-8.472 40.927) rotate(-45)",
    width: 23.228,
    x: 33.553,
    y: 27.66
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.02,
    style: {
      fill: "#febc00"
    },
    transform: "translate(-8.472 40.927) rotate(-45)",
    width: 23.228,
    x: 33.553,
    y: 29.68
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6.059,
    style: {
      fill: "#fdfeff"
    },
    transform: "translate(0.812 44.772) rotate(-45)",
    width: 3.03,
    x: 52.936,
    y: 18.376
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.02,
    style: {
      fill: "#dfeaef"
    },
    transform: "translate(1.403 43.344) rotate(-45)",
    width: 3.03,
    x: 51.508,
    y: 18.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.664,22.477l-4.285-4.285,2.143-2.142a2.019,2.019,0,0,1,2.856,0l1.428,1.428a2.02,2.02,0,0,1,0,2.857Z",
    style: {
      fill: "#f74e0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.806,17.478,58.378,16.05a2.019,2.019,0,0,0-2.856,0l-2.143,2.142,1.429,1.429,2.142-2.143A2.021,2.021,0,0,1,59.806,17.478Z",
    style: {
      fill: "#cc2600"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.813 42.472 33.384 41.044 34.813 36.759 39.097 41.044 34.813 42.472",
    style: {
      fill: "#f7d694"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.384 41.044 32.398 43.459 34.813 42.472 33.384 41.044",
    style: {
      fill: "#f74e0c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test2.858eafac2732990b9d85e624df25d567.svg";
export { ForwardRef as ReactComponent };